import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AppConstants } from 'src/app/app-constants';
import { IAssignmentModuleCall } from 'src/app/interfaces/iassignment-module-call';
import { IPracticeCallResult } from 'src/app/interfaces/ipractice-call-result';
import { AssignmentService } from 'src/app/services/learner/assignment.service';
@Component({
  selector: 'app-previous-results-modal',
  templateUrl: './previous-results-modal.component.html',
  styleUrls: ['./previous-results-modal.component.scss'],
  standalone: false
})
export class PreviousResultsModalComponent {
  @Output() closePreviousResultsEvent = new EventEmitter<void>();
  @Input() callUuid: string | null = null;
  @Input() moduleAssignmentUuid: string | null = null;
  @Input() scoreCriteria: number = 5;
  @Input() callName: string = '';
  @Input() callType: string = AppConstants.CALL_TYPE_GUIDED;
  @Input() assignmentType: string | undefined;
  @Input() call: IAssignmentModuleCall | undefined;
  @Input() callScoreCalcType: string | undefined;

  typePractice: string = AppConstants.TYPE_PRACTICE;
  callTypeGuided: string = AppConstants.CALL_TYPE_GUIDED;
  callTypeConversational: string = AppConstants.CALL_TYPE_CONVERSATIONAL;

  isFadingOut: boolean = false;
  isLoading: boolean = true;
  tooltipText: string = 'Must achieve a 4 or higher';
  practiceCallResults: IPracticeCallResult[] = [];
  calcTypeRatio5pt0min: string = AppConstants.CALL_RATIO_5PT_0MIN;
  private scrollStrategy!: ScrollStrategy;
  lang: string = this.translocoService.getActiveLang() || 'en';

  constructor(
    private assignmentService: AssignmentService,
    private router: Router,
    private overlay: Overlay,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.isFadingOut = false;
    this.tooltipText =
    this.scoreCriteria == 5
      ? `${this.translocoService.translate('MUST_ACHIEVE', {}, 'assignment')} ${this.scoreCriteria}`
      : `${this.translocoService.translate('MUST_ACHIEVE', {}, 'assignment')} ${this.scoreCriteria} ${this.translocoService.translate('OR_HIGHER', {}, 'assignment')}`;
    this.fetchPracticeCallResults();
    this.scrollStrategy = this.overlay.scrollStrategies.block();
    this.scrollStrategy.enable();
  }

  close(): void {
    this.isFadingOut = true;
    this.scrollStrategy.disable();

    setTimeout(() => {
      this.closePreviousResultsEvent.emit();
    }, 500);
  }

  fetchPracticeCallResults(): void {
    this.isLoading = true;
    if (!this.callUuid || !this.moduleAssignmentUuid) {
      console.error(
        `Call UUID [${this.callUuid}] or Module Assignment UUID [${this.moduleAssignmentUuid}] not found`
      );
      return;
    }

    this.assignmentService
      .getPracticeCallResults(this.callUuid, this.moduleAssignmentUuid)
      .subscribe({
        next: (dataResponse: IPracticeCallResult[]) => {
          this.practiceCallResults = dataResponse;
        },
        error: (err) => {
          console.error(
            'Error occurred in fetching practice call results: ',
            err
          );
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  private getResultsPath(): string {
    const isGuided = this.callType === AppConstants.CALL_TYPE_GUIDED;

    if (isGuided) {
      return this.call?.visualAidEnabled
        ? '/results_visual_aid'
        : '/results_guided';
    }

    if (this.callType === AppConstants.CALL_TYPE_CONVERSATIONAL) {
      return '/results_conversational';
    }

    return '/results_guided';
  }

  getResultsQueryParams(practiceCallUuid: string): { [key: string]: string } {
    const isGuided = this.callType === AppConstants.CALL_TYPE_GUIDED;
    const queryParams: { [key: string]: string } = {
      practiceCallUuid: practiceCallUuid,
    };

    if (isGuided) {
      if (this.callUuid !== null) {
        queryParams['callUuid'] = this.callUuid;
      }
    } else if (this.callType === AppConstants.CALL_TYPE_CONVERSATIONAL) {
      if (this.callUuid !== null) {
        queryParams['callUuid'] = this.callUuid;
      }
      if (this.moduleAssignmentUuid !== null) {
        queryParams['moduleAssignmentUuid'] = this.moduleAssignmentUuid;
      }
    } else {
      if (this.callUuid !== null) {
        queryParams['callUuid'] = this.callUuid;
      }
    }

    return queryParams;
  }

  viewFeedback(practiceCallUuid: string): void {
    if (!practiceCallUuid) {
      console.error('Practice Call UUID not found');
      return;
    }

    const resultsPath = this.getResultsPath();
    const queryParams = this.getResultsQueryParams(practiceCallUuid);

    const returnUrl = `${resultsPath}?${new URLSearchParams(queryParams).toString()}`;

    localStorage.setItem('returnUrl', encodeURIComponent(returnUrl));

    this.scrollStrategy.disable();
    this.router.navigate([resultsPath], { queryParams });
  }

}
